module.exports = __webpack_public_path__ + "static/media/Home1.6b7f16bd.png";